import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ukFlag from '../images/uk-flag.png';
import itFlag from '../images/italy.png';
import frFlag from '../images/france.png';
import deFlag from '../images/germany.png';

const LanguageDropdown = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: t('language_en'), flag: ukFlag },
    { code: 'it', name: t('language_it'), flag: itFlag },
    { code: 'fr', name: t('language_fr'), flag: frFlag },
    { code: 'de', name: t('language_de'), flag: deFlag },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <div 
      ref={dropdownRef} 
      className={`language-dropdown ${className}`}
      style={{
        position: 'relative',
        display: 'inline-block',
        zIndex: 1000,
      }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          background: 'transparent',
          border: '1px solid #29B185',
          borderRadius: '4px',
          padding: '4px 8px',
          cursor: 'pointer',
          color: '#29B185',
          fontWeight: 'bold',
          fontSize: '14px',
        }}
      >
        <img 
          src={currentLanguage.flag} 
          alt={currentLanguage.name}
          style={{
            width: '20px',
            height: '15px',
            marginRight: '8px',
            objectFit: 'cover',
          }}
        />
        {currentLanguage.code.toUpperCase()}
      </button>
      
      {isOpen && (
        <div 
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            minWidth: '120px',
            zIndex: 1001,
            marginTop: '4px',
          }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                padding: '8px 12px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '14px',
                color: i18n.language === lang.code ? '#29B185' : '#333',
                fontWeight: i18n.language === lang.code ? 'bold' : 'normal',
                backgroundColor: i18n.language === lang.code ? '#f0f9f5' : 'transparent',
              }}
            >
              <img 
                src={lang.flag} 
                alt={lang.name}
                style={{
                  width: '20px',
                  height: '15px',
                  marginRight: '8px',
                  objectFit: 'cover',
                }}
              />
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
